import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const transactionSchema: Schema = {
  title: 'Transaction',
  level: 1,
  columns: commonColumns
}
